// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class RulesRunnerService {

//   constructor() { }

//   /**
//    * Runs a set of rules against a data object
//    *
//    * DEV NOTE: Generated from Copilot using prompt: write a runesRunner service that has a function runRules which accepts two parameters, a data object and a string such as this "job.status=FINEX|return.closed=1|replace.closed=1|!replace.ediId". It will traverse the object's properties and check references and values based on the rules defined in the string parameter.
//    *
//    * @param data any shape of object
//    * @param rules Example: 'key1=value1|key2.nestedkey1=value2|!key' (can be negated with !) can be nested with dots
//    * @returns boolean - 'true' if all conditions are met
//    */
//   runRules(data: any, rules: string): boolean {
//     const conditions = rules.split('|');
//     for (const condition of conditions) {
//       const negate = condition.startsWith('!');
//       const [key, value] = condition.replace('!', '').split('=');
//       const keys = key.split('.');
//       let objValue = data;

//       for (const k of keys) {
//         if (objValue == null) break;
//         objValue = objValue[k];
//       }

//       if (negate) {
//         if (objValue != null) return false;
//       } else {
//         if (objValue == null || objValue.toString() !== value) return false;
//       }
//     }
//     return true;
//   }
// }

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RulesRunnerService {

  constructor() { }

  /**
   * runRules Function:
   * Splits the rule string into individual conditions using |.
   * Initializes the result to true.
   * Iterates over each condition, checking if it's negated and parsing it.
   * Evaluates each condition using the evaluateCondition function.
   * Combines the results based on whether the condition is negated.
   * evaluateCondition Function:
   *
   * Splits the property path by dots to handle nested properties.
   * Retrieves the value from the data object using getPropertyValue.
   * Evaluates the condition based on the type of the property value (string, number, boolean, array).
   * getPropertyValue Function:
   *
   * Recursively navigates through the nested object structure to get the value of the specified property.
   *
   * @param data - any object
   * @param ruleString - Example Rule string: "job.status=FINEX|return.closed=1|replace.closed=1|!replace.ediId"
   * @returns boolean - 'true' if all conditions are met
   */
  runRules(data: any, ruleString: string): boolean {
    if (!ruleString) return true;

    // Split the rule string by '|'
    const conditions = ruleString.split('|');

    // Initialize result to true
    let result = true;

    for (let condition of conditions) {
      // Check if the condition is a negation
      const isNegated = condition.startsWith('!');
      if (isNegated) {
        condition = condition.substring(1);
      }

      // Parse the condition into property and value
      const parts = condition.split('=');
      // if (parts.length !== 2) continue;
      // console.log(parts);
      const prop = parts[0]?.trim() || undefined;
      const value = parts[1]?.trim() || undefined;

      // Evaluate the condition
      let conditionResult = false;
      try {
        // console.log(data, prop, value);
        conditionResult = this.evaluateCondition(data, prop, value);
        // console.log(conditionResult);
      } catch (e) {
        console.error(`Error evaluating condition ${condition}:`, e);
        conditionResult = false; // Default to false if evaluation fails
      }

      // Combine results based on negation and logical operator
      if (isNegated) {
        result &&= !conditionResult;
      } else {
        result &&= conditionResult;
      }
    }
    // console.log('final result:', result);
    return result;
  }

  private evaluateCondition(data: any, prop: string, value: string): boolean {
    // Get the property value from the data object
    const propValue = this.getPropertyValue(data, prop);

    if (propValue === undefined) return false;

    if(value === undefined) return !!propValue;// not comparing actual values, just truthyness

    // Evaluate the condition based on the type of value
    if (typeof propValue === 'string') {
      return propValue.toUpperCase() === value.toUpperCase();
    } else if (typeof propValue === 'number' || typeof propValue === 'boolean') {
      return propValue.toString() === value;
    } else if (Array.isArray(propValue)) {
      return propValue.includes(value);
    }

    return false;
  }

  private getPropertyValue(data: any, prop: string): any {
    const parts = prop.split('.');
    let current = data;

    for (const part of parts) {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
      } else {
        return undefined;
      }
    }

    return current;
  }
}
